<template>
  <v-row>
    <v-card max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.orders')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-col v-if="!chart" cols="12" align="center" style="height: 400px">
          <v-progress-circular
          style="margin-top: 150px"
            :size="100"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
        <div id="chart"></div>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Resume",
  data() {
    return {
      type: "bar",
      chart: null
    };
  },
  mounted() {
    setTimeout(() => this.render(), 0)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    render() {
      let categories = this.categories();
      let series = this.series();
      if (this.chart) {
        this.chart.updateOptions(
          {
            series: series,
            xaxis: {
              categories: categories
            },
            yaxis: {
              min: 0
            },
            chart: {
              type: this.type
            }
          },
          true
        );
      } else {
        this.chart = new ApexCharts(document.querySelector("#chart"), {
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type,
            height: 400
          }
        });
        this.chart.render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week + 1; index++) {
        categories.push(this.$t("general.smallWeek") + index);
      }
      return categories;
    },
    series() {
      let series = [];
      this.$store.getters["game/companies"].forEach(company => {
        if (company.assemblyMode) {
          for (const supplier of company.data.suppliers) {
            series.push({
              name: company.name + ' -> ' + this.getCompanyName(this.$store.getters["game/companies"], supplier.supplier.toString()),
              data: [company.firstOrder, ...supplier.orders]
            });
          }
        } else {
          if (company.simulatedCompany) {
            series.push({
              name: company.name,
              data: [...company.data.value.orders]
            });
          } else if(company.productionCompany) {
            series.push({
              name: company.name,
              data: [company.firstProduction, ...company.data.value.orders]
            });
          } else {
            series.push({
              name: company.name,
              data: [company.firstOrder * company.suppliers.length, ...company.data.value.orders]
            });
          }
        }
      });
      return series;
    },
    async changeType() {
      await this.chart.destroy();
      this.chart = null;
      if (this.type == "line") {
        this.type = "bar";
      } else {
        this.type = "line";
      }
      this.render();
    },
    getCompanyName(companies, id) {
      for (const company of companies) {
        if (company._id.toString() === id) {
          return company.name
        }
      }
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        if (company.data.value.orders.length > max) {
          max = company.data.value.orders.length;
        }
      });
      return max;
    }
  }
};
</script>
